module.exports = __webpack_public_path__ + "img/5g.8a8340da.png";